var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconConversation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.383,
    height: 17.383,
    viewBox: "0 0 17.383 17.383",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-conversation",
    transform: "translate(-0.975 -0.975)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_430",
    "data-name": "Path 430",
    d: "M20.951,18.969a4.839,4.839,0,0,0,1.7-3.6,4.831,4.831,0,0,0-1.876-3.748,6.9,6.9,0,0,0-4.388-1.5A6.9,6.9,0,0,0,12,11.624a4.681,4.681,0,0,0,0,7.5,6.9,6.9,0,0,0,4.388,1.5c.22,0,.442-.01.662-.029l.376.325a7.113,7.113,0,0,0,4.657,1.737h.569V21.44l-.167-.167a7.088,7.088,0,0,1-1.534-2.3Zm-2.78,1.085-.753-.653-.251.031a6.415,6.415,0,0,1-.778.048c-2.826,0-5.125-1.843-5.125-4.108s2.3-4.108,5.125-4.108,5.125,1.843,5.125,4.108a3.739,3.739,0,0,1-1.585,2.967l-.328.252.151.428A8.231,8.231,0,0,0,21.1,21.432,5.973,5.973,0,0,1,18.171,20.054Z",
    transform: "translate(-4.445 -4.445)",
    fill: "#45338c",
    stroke: "#45338c",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_431",
    "data-name": "Path 431",
    d: "M2.7,11.854A7.847,7.847,0,0,0,3.936,9.612l.15-.426-.327-.252a3.526,3.526,0,0,1-1.5-2.8C2.264,4,4.435,2.264,7.1,2.264A5.018,5.018,0,0,1,11.52,4.552c.141-.007.282-.011.424-.011q.428,0,.848.042a4.938,4.938,0,0,0-1.5-2.027A6.588,6.588,0,0,0,7.1,1.125,6.589,6.589,0,0,0,2.917,2.556,4.618,4.618,0,0,0,1.125,6.138,4.622,4.622,0,0,0,2.736,9.563a6.705,6.705,0,0,1-1.444,2.161l-.167.167v1.191h.569a6.784,6.784,0,0,0,3.033-.716,5.6,5.6,0,0,1-.18-1.2,5.649,5.649,0,0,1-1.849.685Z",
    fill: "#45338c",
    stroke: "#45338c",
    strokeWidth: 0.3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconConversation);
export default __webpack_public_path__ + "static/media/icon-conversation.d53c882bd1a2b38d04cce1d08171a780.svg";
export { ForwardRef as ReactComponent };